import { useLocation } from "wouter";
import { Logo } from "../../../ui/icons";

interface AuthNavProps {
  readonly isDark: boolean;
  readonly onToggleTheme: () => void;
}

export function AuthNav({ isDark, onToggleTheme }: AuthNavProps) {
  const [, navigate] = useLocation();

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-surface/80 backdrop-blur-xl border-b border-border pt-[env(safe-area-inset-top)]">
      <div className="max-w-5xl mx-auto px-6 h-14 flex items-center justify-between">
        <button
          onClick={() => navigate("/")}
          className="flex items-center gap-2 text-lg font-bold text-ink tracking-tight"
        >
          <Logo className="size-6" />
          Palnia
        </button>

        <button
          onClick={onToggleTheme}
          className="w-9 h-9 flex items-center justify-center rounded-xl
            text-ink-muted hover:text-ink hover:bg-surface-alt transition-colors"
          aria-label="Changer le thème"
        >
          {isDark ? (
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="5" />
              <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" />
            </svg>
          ) : (
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" />
            </svg>
          )}
        </button>
      </div>
    </nav>
  );
}
